import React from 'react'
import { Link } from 'react-router-dom'

import { ReactComponent as Arrow } from '../../assets/icons/button_arrow.svg'
import pic1 from '../../assets/img/picture_1.png'
import pic2 from '../../assets/img/picture_2.png'
import pic3 from '../../assets/img/cat_4.PNG'
import pic4 from '../../assets/img/cats_pool.PNG'
import pic5 from '../../assets/img/cat_5.PNG'
import pic6 from '../../assets/img/spoiler.png'

import './Home.scss'

export const Home = () => {
  const gtag = () => {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-970914587/s1WFCP35nfYCEJv2-84D',
      'event_callback': () => {}
    })
  }

  return (
    <div className="home-container">
      <section className="lead">
        <div className="row">
          <div className="content">
            <div className="text-wrapper">
              <h1>
                TRON 区块链上最酷的猫
              </h1>
              <p>
                生成的小猫 NFTS
              </p>
            </div>
            <Link to="/mint" className="link-button" onClick={ gtag }>
              <span>
                铸造 TRON 酷猫
              </span>
              <Arrow />
            </Link>
          </div>
          <div className="picture">
            <img src={ pic1 } alt="cats" />
          </div>
        </div>
      </section>
      <section className="second">
        <div className="row">
          <div className="content">
            <h1>
              <span className="text-red">Tron</span> Cool Cats 是什么？
            </h1>
            <p>
              Tron Cool Cats是10,000 只酷猫NFTs的集合—在Tron区块链上喵喵叫的独特随机生成的数字收藏品。 随机Cool cats系列拥有各种表情，服装，配饰和其他特征，以保证你的酷猫的迷死。 就像最初的基于以太坊的Cool cats一样，所有Tron酷猫都是独一无二的，令人难以置信的可爱。 毫无疑问，所有的猫都很酷，但是当一个人的外观完成了罕见的特质，配件和完整的装备—一只酷猫成为最酷的猫。 请记住，每一只很酷猫被铸造是一个独特的收藏品，你现在在喵喵的可能性的世界！
            </p>
            <a
              className="wp-link"
              href="https://telegra.ph/Whitepaper-CoolCatsTron-09-19"
              target="_blank"
              rel="noopener noreferrer"
            >
              Meowsome Cool Cats WhitePaper!
            </a>
          </div>
          <div className="picture">
            <img src={ pic2 } alt="cats" />
          </div>
        </div>
      </section>
      <section className="third">
        <div className="row">
          <div className="picture round">
            <img src={ pic3 } alt="cat" />
          </div>
          <div className="content">
            <h1>
              为什么要购买Tron Cool Cat NFTs？
            </h1>
            <p>
              首先，酷猫很酷，这使得它们的主人非常酷。 其次，有史以来第一次，你会从一个令人敬畏的Tron网络中获得一只令人敬畏的小猫-这是世界上最着名的区块链之一，拥有快速增长的NFT市场。 这就是Tron造历史的方式。
            </p>
          </div>
        </div>
        <div className="row">
          <div className="content">
            <h1>
              对社区有什么好处？
            </h1>
            <p>
              我们正在建立一个基于Tron酷猫主人的史诗般的社区。 所以......我们将为30+和150+ 酷猫主人推出10％的游泳池！ 我们将向Tron酷猫NFT 收藏家返还铸币所筹集的所有TRX的10％。 拥有30+ 酷猫NFTs的主人将分享3％，拥有150+NFTs的最大的酷猫粉丝将分享7％。 听起来怎么样？ 就像一只"喵"！
            </p>
          </div>
          <div className="picture pool">
            <img src={ pic4 } alt="cats pool" />
          </div>
        </div>
        <div className="row">
          <div className="picture round">
            <img src={ pic5 } alt="cat" />
          </div>
          <div className="content">
            <h1>
              好吧，一只酷猫多少钱？
            </h1>
            <p>
              所有的猫都被随机铸造。Tron酷猫的铸造成本固定在1500TRX。 基于以太坊的酷猫的价格如此之高，基于Tron猫的推出对收藏家来说是一个独特的投资机会。 酷猫都是不同的，但他们的成本是每个人都一样。 在Tron酷猫世界中没有价格层。
            </p>
          </div>
        </div>
      </section>
      <section className="fourth">
        <div className="column">
          <div className="picture">
            <img src={ pic6 } alt="secret cats" />
          </div>
          <h1>
            剧透警报！
          </h1>
          <p>
            我们还为Tron爱好者开发了独家酷猫系列。 根据您最喜欢的电影角色，还有一只酷猫的猫科动物家庭。 请继续关注插图画家的更多细节！ 订阅并成为我们酷猫社区的一份子。
          </p>
        </div>
      </section>
    </div>
  )
}